import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, switchMap, take } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  let authSrv: AuthService = inject(AuthService);
  let toast: ToastrService = inject(ToastrService);
  let router = inject(Router);

  const urlCurrent = state.url;

  const existingToken = authSrv.getAccessToken();
  const existingIdCard = authSrv.getUserLogInIdCard();
  const citizen_id = route.queryParams['ID'];
  const system_id = route.queryParams['system_id'];
  const tokenParam = route.queryParams['token'];
  const userTypeParam = route.queryParams['user_type'];

  const hasLoginQueryParams = !!(
    citizen_id ||
    tokenParam ||
    system_id ||
    userTypeParam
  );

  if (hasLoginQueryParams) {
    toast.error('ไม่อนุญาตให้ล็อกอินผ่าน URL', 'ขออภัยเกิดข้อผิดพลาด', {
      timeOut: 1500,
      progressBar: true,
    });

    // router.navigateByUrl('/unauthorized');
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    authSrv.removeAccessParam();
    return of(false);
  }

  if (existingToken && existingIdCard) {
    const savedType = authSrv.getSavedSubMenuCode?.(urlCurrent) || '';
    return authSrv.currentUserLogin$.pipe(
      take(1),
      switchMap((user) => {
        if (user) {
          return of(true);
        }
        return authSrv.userLogin(existingIdCard, userTypeParam || savedType);
      }),
      map((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          authSrv.removeAccessParam();
          router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          // router.navigateByUrl('/unauthorized');
          // toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
          //   timeOut: 1500,
          //   progressBar: true,
          // });
        }
        return isAuthenticated;
      }),
      catchError(() => {
        authSrv.removeAccessParam();
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        // router.navigateByUrl('/unauthorized');
        // toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
        //   timeOut: 1500,
        //   progressBar: true,
        // });
        return of(false);
      })
    );
  }

  // toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
  //   timeOut: 1500,
  //   progressBar: true,
  // });

  // router.navigateByUrl('/unauthorized');
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  authSrv.removeAccessParam();

  return of(false);
};
